import { Trophy } from 'lucide-react'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'

const RankingPage = lazyPage(() => import('@/pages/Ranking'), 'RankingPage')

export const rankingModule: ModuleDefinition = {
  key: 'ranking',
  icon: Trophy,
  iconName: 'trophy',
  namespaces: ['ranking'],
  ready: true,
  ListPage: RankingPage
}
